import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import AllergenCard from './allergen-card';
import { TAllergen } from '../schemas';

type AllergenListProps = {
  allergens: TAllergen[];
  onEdit: (allergen: TAllergen) => void;
  onDelete: (allergen: TAllergen) => void;
};

const AllergenList = ({ allergens, onEdit, onDelete }: AllergenListProps) => {
  if (!allergens || allergens.length === 0) {
    return (
      <Box sx={styles.emptyContainer}>
        <Typography sx={styles.emptyText}>No allergens found</Typography>
      </Box>
    );
  }

  return (
    <Grid container spacing={2} alignItems="flex-start">
      {allergens.map((allergen) => (
        <Grid item xs={12} sm={6} md={6} lg={6} key={allergen._id}>
          <AllergenCard allergen={allergen} onEdit={onEdit} onDelete={onDelete} />
        </Grid>
      ))}
    </Grid>
  );
};

export default AllergenList;

const styles = {
  emptyContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem',
    backgroundColor: '#f5f5f5',
    borderRadius: 2,
    minHeight: '150px',
  },
  emptyText: {
    color: '#666',
    fontSize: 14,
    fontFamily: 'GilroyRegular',
  },
};
